{
  "app": {
    "name": "POSS",
    "legend": "Pacific One Stop Shop"
  },
  "dashboard": {
    "actualSituation": "Situation actuelle",
    "payments": "Paiements",
    "totalAmount": "Montant total",
    "currentAccount": "Compte courant"
  },
  "config": {
    "tin": "PIN",
    "tinLegend": "POSS Identification Number"
  },
  "amendment-create": {
    "title": {
      "dialog-confirm": "Envoyer la déclaration"
    },
    "label": {
      "taxReturn": "Numéro de déclaration à rectifier"
    },
    "messages": {
      "confirm": "Êtes-vous sûr de vouloir effectuer cette action?"
    }
  },
  "statement-submit-amendment": {
    "title": {
      "page": "Rectifier l'instruction"
    },
    "label": {
      "taxReturn": "Déclaration",
      "year": "Période"
    },
    "messages": {},
    "validations": {},
    "button": {
      "file": "Rectifier"
    }
  },
  "statement-submit-statement": {
    "title": {
      "page": "Déposer une déclaration fiscale",
      "subtitle": "Veuillez compléter les informations afin d’identifier l’impôt et la période à déclarer"
    },
    "label": {
      "fileStatement": "Produire une déclaration de revenus",
      "taxReturn": "Déclaration d'impôt",
      "year": "Période"
    },
    "messages": {
      "formVersionNotFound": "Une version actuelle et active est introuvable",
      "taxReturnExist": "La déclaration existe déjà pour cette période",
      "validPeriod": "La période sélectionnée n'est pas valide pour cette taxe"
    }
  },
  "taxreturns": {
    "title": {
      "dialog-confirm": "Envoyer la déclaration"
    },
    "messages": {
      "successfully": "La déclaration avec la période [period] a été envoyée avec succès le [createDate]",
      "successfullyApprovalRequired": "La déclaration rectificative ayant réduit la taxe, elle sera soumise à un processus de révision pour approbation ou rejet par l'administration fiscale.",
      "confirm": "Êtes-vous sûr de vouloir effectuer cette action?",
      "backToHome": "Retour au début"
    }
  },
  "formDefinition": {
    "label": {
      "reconecting": "Reconnexion",
      "reconected": "Reconnecté"
    }
  },
  "administration-user": {
    "title": {
      "page": "Utilisateur",
      "page-taxpayer": "Les contribuables"
    },
    "label": {
      "userName": "Nom de l'utilisateur",
      "department": "département",
      "roles": "Les rôles",
      "user": "Nouvel utilisateur",
      "disabled": "Désactivée",
      "locale": "Langue préférée",
      "disable": "Pour désactiver",
      "enable": "Activer",
      "cancel": "Annuler"
    },
    "validations": {
      "userName": "Le nom d'utilisateur est requis"
    },
    "messages": {
      "disableTitle": "Désactiver l'utilisateur",
      "confirmDisable": "Voulez-vous vraiment désactiver cet utilisateur?",
      "confirmEnable": "Voulez-vous vraiment activer cet utilisateur?",
      "savedSucessfully": "Enregistré avec succès",
      "enableTitle": "Activer l'utilisateur",
      "error": "Erreur"
    }
  },
  "user-profile": {
    "title": {
      "page": "Profil de l'utilisateur",
      "change-password": "Changer le mot de passe"
    },
    "label": {
      "userName": "Nom de l'utilisateur",
      "name": "nom",
      "email": "Email",
      "locale": "langue préférée",
      "currentPassword": "Mot de passe actuel",
      "newPassword": "Nouveau mot de passe",
      "repeatPassword": "Répéter le mot de passe",
      "change-password": "Changer le mot de passe",
      "password": "Mot de passe"
    },
    "message": {
      "password-changed": "Le mot de passe a été changé avec succès",
      "profile-updated": "Mise à jour du profil réussie. Vous devez vous reconnecter pour voir les changements",
      "password": "Mettez à jour le mot de passe de votre compte pour assurer la sécurité de votre compte"
    }
  },
  "inbox-notifications": {
    "title": {
      "inbox": "Boites aux lettres"
    },
    "label": {
      "message": "message",
      "messages": "messages",
      "read": "Lis",
      "inboxDate": "Date",
      "ok": "OUI",
      "no": "NE PAS"
    }
  },
  "parameters-catalog": {
    "title": {
      "catalogType": "Type de catalogue",
      "catalog": "Catalogue"
    },
    "label": {
      "type": "Nett",
      "name": "nom",
      "description": "La description",
      "field": "Campagne",
      "label": "Hashtag",
      "parent": "Papa",
      "newCatalogType": "nouveau type de catalogue",
      "newCatalog": "Nouveau catalogue",
      "code": "Code",
      "addDefinition": "Ajouter une définition",
      "newDefinition": "Nouvelle définition",
      "extaFilds": "Champs utilisateur supplémentaires",
      "addNameTraslation": "Ajouter une traduction"
    },
    "validations": {
      "exists": "L'enregistrement existe déjà",
      "letterNumberhyphen": "Seuls les lettres, les chiffres et les traits d'union sont autorisés"
    },
    "messages": {
      "languageExist": "La langue a déjà été ajoutée"
    }
  },
  "taxpayer-fields": {
    "title": {
      "page": "Champs du contribuable",
      "enabled": "Activée"
    },
    "header": {
      "fieldCode": "Code",
      "fieldName": "nom",
      "fieldSection": "Section",
      "actions": "Activée"
    },
    "messages": {
      "savedSucessfully": "Informations stockées avec succès"
    }
  },
  "common": {
    "label": {
      "theme": "Thème",
      "captcha-placeholder": "Entrez Captcha",
      "feedback": "Retour d'information",
      "logout": "Se déconnecter",
      "print": "Imprimer",
      "phoneNumberArea": "Indicatif",
      "current-user": "Utilisateur actuel",
      "user-profile": "Profil de l'utilisateur",
      "name": "nom",
      "givenNames": "Noms",
      "surnames": "Prénoms",
      "search": "Chercher",
      "clean": "Nettoyer",
      "create": "Nouveau",
      "ok": "Accepter",
      "next": "Suivant",
      "cancel": "Annuler",
      "back": "Retourner",
      "edit": "Éditer",
      "actions": "Actions",
      "send": "Envoyer",
      "close": "Fermer",
      "add": "Ajouter",
      "email": "Email",
      "phoneNumber": "Téléphone",
      "id": "Va",
      "password": "Mot de passe",
      "state": "Désactivée",
      "translation": "Übersetzung",
      "language": "langage",
      "value": "Wert",
      "translatable": "Übersetzbar",
      "politicalDivision": "Division politique",
      "department": "Département / Province / État",
      "city": "Ville",
      "zipCode": "Poste",
      "cellPhone": "Mobile",
      "personType": "Genre de personne",
      "businessName": "Nom ou raison sociale",
      "taxpayerName": "Nom ou raison sociale",
      "tradeName": "Nom commercial",
      "address": "Adresse",
      "country": "Pays",
      "localization": "Emplacement",
      "website": "Site web",
      "fileSearch": "Rechercher un fichier",
      "fileUpload": "Datei hochladen",
      "fileDownload": "Télécharger un fichier",
      "noFileSelected": "Aucun fichier choisi",
      "fileRequirements": "PDF · Max. 9,6 Mo",
      "fileUploading": "Téléversement...",
      "fileUploaded": "Téléversé",
      "fileUploadError": "Le fichier n’a pas pu être téléversé",
      "fileSelect": "Sélectionner",
      "fileReplace": "Remplacer",
      "fileRemove": "Supprimer",
      "fileRemoving": "Suppression...",
      "fileRemoveError": "Le fichier n’a pas pu être supprimé",
      "dateFrom": "Dater de",
      "dateTo": "Date au",
      "noFound": "Il n'y a pas de résultat",
      "taxReturnCurrency": "Déclaration de devise",
      "page-showing": "Montrant",
      "page-to": "à",
      "page-of": "de",
      "page-entries": "records",
      "loading": "Mise en charge...",
      "error": "Erreur",
      "unableToLoad": "Impossible de charger les données. Veuillez réessayer.",
      "retry": "Réessayer",
      "currency": "Devise",
      "paymentMethod": "Procédé de paiement",
      "attachment": "Attacher",
      "paymentReference": "Plus d'informations",
      "supportDocument": "Document d'assistance",
      "payment": "Paiement",
      "backToHome": "Retour au début",
      "bank": "Banque",
      "bankInformation": "Informations bancaires",
      "excel": "Excel",
      "days": {
        "monday": "lun",
        "tuesday": "Ma",
        "wednesday": "Mich",
        "thursday": "Je ",
        "friday": "ven",
        "saturday": "Sam",
        "sunday": "Di"
      },
      "months": {
        "january": "janvier",
        "february": "février",
        "march": "Mars",
        "april": "avril",
        "may": "Mai",
        "june": "juin",
        "july": "juillet",
        "august": "août",
        "september": "septembre",
        "october": "Octobre",
        "november": "novembre",
        "december": "décembre"
      }
    },
    "descriptions": {
      "taxReturnCurrency": "Monnaie à utiliser pour les déclarations",
      "contactTaxIdNumber-tax": "Numéro d'identification fiscale du contact dans le pays de résidence"
    },
    "button": {
      "add": "Ajouter",
      "edit": "Éditer",
      "find": "Chercher",
      "cancel": "Annuler",
      "delete": "Se débarrasser de",
      "save": "Enregistrer",
      "submitTaxReturn": "Soumettre la déclaration fiscale",
      "clean": "Nettoyer",
      "new": "Nouveau",
      "show": "Regarder",
      "download": "Télécharger",
      "file": "Attacher",
      "previous": "Précédent",
      "next": "Suivant",
      "send": "Envoyer",
      "translate": "Traductions",
      "return": "Revenir",
      "continue": "continuer",
      "newVersion": "Nouvelle version"
    },
    "dialog": {
      "dialog-error": "Erreurs",
      "table-title-header": "messages",
      "warning-title": "Attention"
    },
    "messages": {
      "error-500": "Une erreur s'est produite lors de l'opération",
      "fileUpload": "Le fichier a été téléchargé avec succès",
      "fileUploadMaxSize": "La taille du document ne peut pas dépasser 10 Mo",
      "savedSucessfully": "Stocké avec succès",
      "deletedSucessfully": "Supprimé avec succès",
      "pleaseWait": "S'il-vous-plaît attendez",
      "warningInactiveSession": "Attention: aucune activité n'a été détectée depuis un certain temps. La session sera fermée dans 1 minute si aucune activité n'est encore détectée",
      "sessionIdleCountdown": "Votre session se fermera dans {{count}} secondes.",
      "closingSession": "Séance de clôture ...",
      "warningCancelOperation": "Si vous annulez l'opération, vous perdrez les données saisies. Voulez-vous continuer?",
      "confirm": "Êtes-vous sûr de vouloir effectuer cette action?",
      "feedback": "Merci pour votre avis",
      "feedbackIntro": "Vos commentaires seront envoyés à l'Administration pour connaître votre expérience avec le système et pouvoir vous fournir un meilleur service.",
      "messageSent": "Message envoyé avec succès"
    },
    "validations": {
      "nameRequired": "Il est requis de compléter le champ correspondant au nom",
      "fieldRequired": "Ce champ est requis",
      "mapRequired": "Sie müssen eine Position auf der Karte auswählen",
      "numbersAndLetters": "Seulement des chiffres et des lettres",
      "email": "Email invalide",
      "minStringValue": "Le champ doit contenir au moins {{min}} caractères",
      "maxStringValue": "Le champ doit contenir au maximum {{max}} caractères",
      "minNumberValue": "La valeur du champ doit être minimale {{min}}",
      "maxNumberValue": "La valeur du champ doit être au maximum {{max}}",
      "urlInvalid": "Das URL-Format ist ungültig",
      "captchaValidationRequired": "La validation du captcha est requise"
    },
    "languages": {
      "spanish": "Espagnol (Espagne)",
      "english": "États Unis Anglais)"
    },
    "taxpayer-request-types": {
      "enroll": "Enregistrement",
      "update": "Aktualisierung"
    },
    "taxpayer-request-states": {
      "pending": "En attente",
      "pending_additional_information": "En attente d'informations supplémentaires",
      "approved": "Approuvé",
      "rejected": "Rejeté"
    },
    "taxreturn-types": {
      "original": "Original",
      "amending": "Rectifier"
    },
    "taxreturn-status": {
      "pending": "En attente",
      "accepted": "Accepté",
      "approved": "Approuvé",
      "rejected": "Rejeté",
      "reconciled": "Réconcilié"
    },
    "yes-no": {
      "yes": "Ja",
      "no": "NE PAS"
    }
  },
  "report-file": {
    "title": {
      "page": "Pièce jointe au rapport complémentaire",
      "dialog": "Le rapport existe déjà",
      "dialog-confirm": "Envoyer un rapport"
    },
    "label": {
      "header": "Tête de lit",
      "description": "La description",
      "type": "Nett",
      "file": "Rapport complémentaire",
      "loading": "Mise en charge...",
      "definition": "Définition de fichier (.csv, .xls, .xlsx)"
    },
    "button": {
      "attachment": "Joindre le rapport"
    },
    "messages": {
      "dialog": "Un rapport a déjà été soumis pour la période sélectionnée, souhaitez-vous remplacer le rapport existant par une nouvelle version?",
      "confirm": "Êtes-vous sûr de vouloir effectuer cette action?",
      "successfully": "Le rapport supplémentaire avec la période [period] a été envoyé avec succès le [createDate]",
      "backToHome": "Retour au début"
    }
  },
  "report-details": {
    "stateType": {
      "processing": "Traitement",
      "error": "Erreur",
      "accepted": "Accepté",
      "processed": "Traité"
    },
    "title": {
      "page": "Consultation des rapports"
    },
    "label": {
      "reportNumber": "Signaler le numéro",
      "reportType": "Type de rapport",
      "operations": "Type d'opération",
      "taxpayerNumber": "Numéro d'identification fiscale",
      "taxpayerName": "Nom du contribuable",
      "registrationDate": "Date d'inscription",
      "period": "Période",
      "reportName": "Nom du rapport",
      "record": "Valeurs",
      "index": "Ligne",
      "type": "Nett",
      "active": "actif",
      "taxReportState": "État"
    }
  },
  "report-selection": {
    "label": {
      "fileReport": "Soumettre un rapport supplémentaire",
      "report": "Signaler",
      "year": "Période"
    },
    "messages": {
      "reportVersionNotFound": "Version du rapport introuvable"
    }
  },
  "taxreturn-report": {
    "title": {
      "page": "Voir les déclarations"
    },
    "label": {
      "nit": "Numéro d'identification fiscale",
      "taxreturnNumber": "Numéro de déclaration",
      "country": "Pays",
      "formId": "Forme",
      "taxreturnType": "Type de déclaration",
      "taxreturnStatus": "État",
      "name": "Nom du contribuable",
      "period": "Période",
      "periodFrom": "Dater de",
      "periodTo": "Date jusqu'au",
      "active": "actif",
      "overview": "général",
      "taxreturn": "Déclaration",
      "createDate": "Date",
      "approve": "Approuvé",
      "comments": "commentaires"
    },
    "header": {
      "actions": "Actions",
      "nit": "Numéro d'identification fiscale",
      "name": "Nom du contribuable",
      "taxReturnNumber": "Numéro de déclaration",
      "createDate": "Date",
      "taxreturnType": "Type de déclaration",
      "taxreturnStatus": "État",
      "form": "Forme",
      "period": "Période",
      "active": "actif",
      "rejectionReason": "Raison du rejet"
    },
    "validations": {},
    "messages": {},
    "button": {}
  },
  "form-cells": {
    "title": {
      "page": "Des boites",
      "serviceParameters": "Paramètres de service"
    },
    "label": {
      "code": "Code de boîte",
      "name": "Boîte de nom",
      "description": "La description",
      "section": "Section",
      "formula": "Formule",
      "order": "Ordre",
      "type": "Nett",
      "service": "Un service",
      "mandatory": "Obligatoire",
      "editable": "Modifiable",
      "visible": "Sichtbar",
      "cellPurpose": "Finalité de la cellule",
      "numeric": "Numérique",
      "currency": "Devise",
      "date": "Date",
      "list": "Prêt",
      "text": "Texte",
      "catalogType": "Type de catalogue",
      "parameterName": "nom",
      "addParameter": "Ajouter un paramètre"
    },
    "messages": {
      "confirmTitle": "Se débarrasser de",
      "confirmDeleted": "Êtes-vous sûr de vouloir le supprimer?"
    }
  },
  "taxes": {
    "title": {
      "page": "Gérer les taxes"
    },
    "label": {
      "name": "nom",
      "rateType": "Type de taux",
      "shortName": "Nom court",
      "code": "Code",
      "newButton": "Nouveau",
      "saveButton": "Enregistrer",
      "tabEditTax": "général",
      "tabRates": "honoraires",
      "tabPeriodicity": "Périodicité",
      "dateFrom": "Date de",
      "dateTo": "Date au",
      "value": "Wert",
      "periodicityType": "Type de périodicité",
      "filingDueDay": "Date d'expiration"
    },
    "header": {
      "code": "Code",
      "name": "nom",
      "rateType": "Type de taux",
      "value": "Wert",
      "dateFrom": "Date de",
      "dateTo": "Date au",
      "shortName": "Nom court",
      "actions": "Actions",
      "periodicityType": "Type de périodicité",
      "filingDueDay": "Date d'expiration"
    },
    "validations": {
      "rateTypeRequired": "Le champ de type de taux est obligatoire",
      "shortNameRequired": "Le champ du nom court est obligatoire",
      "codeRequired": "Le champ de code est obligatoire",
      "valueLessThan100": "Le champ de valeur doit être inférieur à 100%",
      "valueRequired": "Le champ de valeur est obligatoire",
      "dateFromRequired": "La date du champ est obligatoire",
      "dateToRequired": "Le champ date à est obligatoire",
      "filingDueDayRequired": "Le champ du jour d'expiration est obligatoire",
      "periodicityTypeRequired": "Le champ de type de périodicité est obligatoire"
    },
    "messages": {
      "savedSuccessfully": "A été enregistré avec succès",
      "deletedSuccessfully": "A été supprimé avec succès",
      "error": "Erreur"
    }
  },
  "reportOperation": {
    "title": {
      "page": "Gérer les rapports d'opérations",
      "warning": "Warnung"
    },
    "label": {
      "operation": "Opération",
      "report": "Signaler"
    },
    "header": {
      "operation": "Opération",
      "report": "Signaler",
      "actions": "Actions"
    },
    "messages": {
      "removeReportOperation": "Êtes-vous sûr de vouloir le supprimer?"
    }
  },
  "report-cells": {
    "title": {
      "page": "Des boites"
    },
    "label": {
      "code": "Code de boîte",
      "name": "Boîte de nom",
      "description": "La description",
      "formula": "Formule",
      "order": "Ordre",
      "type": "Nett",
      "numeric": "Numérique",
      "currency": "Devise",
      "date": "Date",
      "list": "Prêt",
      "text": "Texte",
      "catalogType": "Type de catalogue"
    },
    "messages": {
      "confirmTitle": "Se débarrasser de",
      "confirmDeleted": "Es-tu sûr de vouloir le supprimer?"
    }
  },
  "reports": {
    "title": {
      "page": "Gérer les rapports",
      "report": "Signaler",
      "versions": "Versionen"
    },
    "label": {
      "name": "nom",
      "shortName": "Nom court",
      "code": "Code",
      "newButton": "Nouveau",
      "saveButton": "Enregistrer",
      "tabEditReport": "général",
      "tabPeriodicity": "Périodicité",
      "dateFrom": "Date de",
      "dateTo": "Date au",
      "periodicityType": "Type de périodicité",
      "filingDueDay": "Date d'expiration"
    },
    "header": {
      "code": "Code",
      "name": "nom",
      "shortName": "Nom court",
      "actions": "Actions",
      "dateFrom": "Date de",
      "dateTo": "Date au",
      "periodicityType": "Type de périodicité",
      "filingDueDay": "Date d'expiration"
    },
    "validations": {
      "shortNameRequired": "Le champ du nom court est obligatoire",
      "codeRequired": "Le champ de code est obligatoire",
      "dateFromRequired": "La date du champ est obligatoire",
      "dateToRequired": "Le champ date à est obligatoire",
      "filingDueDayRequired": "Le champ du jour d'expiration est obligatoire",
      "periodicityTypeRequired": "Le champ de type de périodicité est obligatoire"
    },
    "messages": {
      "savedSuccessfully": "A été enregistré avec succès",
      "deletedSuccessfully": "A été supprimé avec succès",
      "error": "Erreur"
    }
  },
  "form-administration": {
    "title": {
      "page": "Formulaire d'administration des déclarations",
      "form": "Forme",
      "versions": "Versionen"
    },
    "label": {
      "code": "Code",
      "name": "nom",
      "shortName": "Nom court",
      "tax": "Impôt",
      "numberModifications": "Nombre d'amendements",
      "amendmentApprovalRequired": "Les modifications doivent être approuvées",
      "form": "Forme",
      "versions": "Versionen"
    },
    "header": {
      "actions": "Actions",
      "code": "Code",
      "name": "nom",
      "shortName": "Nom court",
      "tax": "Impôt"
    },
    "messages": {
      "confirmTitle": "Se débarrasser de",
      "confirmDeleted": "Êtes-vous sûr de vouloir le supprimer?",
      "noCellDefined": "Cher contribuable, ce formulaire a une définition incomplète, contactez l'administrateur"
    }
  },
  "security-apikey": {
    "title": {
      "page": "Clés API"
    },
    "label": {
      "name": "Nobre",
      "new-api-key": "Nouvelle clé",
      "expiration": "Date d'expiration",
      "your-pat": "Ihr neues persönliches Zugriffstoken",
      "revoke-token": "Révoquer le jeton"
    },
    "validations": {
      "name": "Le nom de la clé Api est requis",
      "expiration": "La date d'expiration est requise"
    },
    "message": {
      "key-created": "Assurez-vous de l'enregistrer - vous ne pourrez plus y accéder.",
      "confirm-revoke": "Voulez-vous vraiment révoquer le jeton?"
    }
  },
  "audit-log": {
    "title": {
      "event-title": "Journaux d'événements",
      "command-title": "Journaux de stock",
      "query-title": "Journaux de requête",
      "http-title": "Journaux HTTP",
      "application": "App",
      "security": "Sécurité"
    },
    "label": {
      "dateFrom": "Dater de",
      "dateTo": "Date jusqu'au",
      "user": "Utilisateur",
      "commandName": "Nom de la commande",
      "successfullyExecuted": "Exécution réussie",
      "aggregateName": "Requête de nom",
      "queryName": "Nom de l'entité",
      "eventName": "Nom de l'événement",
      "httpMethod": "Méthode HTTP",
      "httpStatusCode": "Code d'état HTTP"
    },
    "header": {},
    "validations": {
      "dateRequired": "Cette date est obligatoire",
      "dateToGreaterThan": "La date doit être postérieure à la date de début",
      "dateLessThreeMonths": "La date doit être inférieure à 3 mois à compter de la date de début"
    },
    "messages": {}
  },
  "disable-tfa": {
    "label": {
      "title": "Désactiver l'authentification à deux facteurs (2FA)",
      "disable": "Désactiver 2FA"
    },
    "validations": {},
    "message": {
      "alert-1": "Cette action désactive uniquement 2FA.",
      "alert-2": "La désactivation de 2FA ne modifie pas les clés utilisées dans les applications d'authentification.",
      "alert-3": "Si vous souhaitez modifier la clé utilisée dans une application d'authentification, vous devez:",
      "alert-4": "réinitialisez vos clés d'authentification.",
      "success": "2fa a été désactivé. Vous pouvez réactiver 2fa lorsque vous configurez une application d'authentification"
    }
  },
  "enable-authenticator": {
    "label": {
      "title": "Configurer l'application d'authentification",
      "verification-code": "Verifizierungs-Schlüssel",
      "verification-code-digit": "Chiffre {{position}} sur {{total}}",
      "verify": "prüfen",
      "manual-key": "Clé de configuration manuelle",
      "copy-key": "Copier la clé",
      "key-copied": "Clé copiée dans le presse-papiers.",
      "key-copied-button": "Copié",
      "copy-unavailable": "La clé n'a pas pu être copiée. Copiez-la manuellement.",
      "security-recommendations": "Recommandations de sécurité",
      "security-recommendations-detail": "Conservez les codes de récupération dans un endroit sûr et ne partagez pas la clé de configuration."
    },
    "validations": {
      "code": "Le code de vérification est requis"
    },
    "message": {
      "instruction-1": "Téléchargez une application d'authentification telle que Microsoft Authenticator pour",
      "and": "Oui",
      "or": "ou alors",
      "for": "afin de",
      "instruction-2": "Scannez le code QR ou insérez cette clé",
      "instruction-3": "dans votre application d'authentification. Les espaces et les séparateurs n'ont pas d'importance.",
      "instruction-4": " Une fois que vous avez scanné le code QR ou saisi la clé ci-dessus, votre application d'authentification vous fournira un code unique. Entrez le code dans le champ de confirmation ci-dessous."
    }
  },
  "recovery-codes": {
    "label": {
      "title": "Codes de récupération",
      "available-once": "Enregistrez-les maintenant : ils ne seront plus affichés intégralement."
    },
    "message": {
      "save-security-codes": "Conservez ces codes dans un endroit sûr.",
      "if-you-lose": "Si vous perdez votre appareil et ne disposez pas des codes de récupération, vous perdrez l'accès à votre compte."
    }
  },
  "generate-recovery-codes": {
    "label": {
      "title": "Générer des codes de récupération pour l'authentification à deux facteurs (2FA)",
      "generate": "Générer des codes de récupération"
    },
    "validations": {},
    "message": {
      "alert-1": "Mettez ces codes dans un endroit sûr.",
      "alert-2": " Si vous perdez votre appareil et ne disposez pas des codes de récupération, vous perdrez l'accès à votre compte.",
      "alert-3": " Si vous perdez votre appareil et ne disposez pas des codes de récupération, vous perdrez l'accès à votre compte.",
      "alert-4": " réinitialisez vos clés d'authentification."
    }
  },
  "security-login": {
    "title": {
      "login": "Connexion"
    },
    "label": {
      "username": "Utilisateur",
      "password": "Mot de passe",
      "rememberMe": "Souviens-toi de moi",
      "loginButton": "Commencer la session",
      "passwordRecovery": "Récupérer le mot de passe",
      "notRegistered": "Pas encore inscrit?",
      "signup": "S'inscrire",
      "loginAlternative": "ou alors",
      "forgotPassword": " Vous avez oublié votre mot de passe ?",
      "next": "Suivant",
      "forgotPasswordInstructions": "Entrez votre nom d'utilisateur et nous vous enverrons un e-mail avec les instructions pour récupérer",
      "externalLogin": "Connexion externe",
      "captcha-placeholder": "Entrez Captcha"
    },
    "validations": {
      "usernameRequired": "Le champ utilisateur est obligatoire",
      "passwordRequired": "Mot de passe requis",
      "captchaValidationRequired": "La validation du captcha est requise"
    }
  },
  "login-with-2fa": {
    "title": {
      "login": "Zwei-Faktor-Authentifizierung",
      "login-recovery": "Récupérer le code de vérification"
    },
    "label": {
      "twoFactorCode": "Code d'authentification",
      "recoveryCode": "Code de récupération",
      "rememberBrowser": "Souvenez-vous de ce navigateur",
      "verificationCodeInstructions": "Saisissez le code à six chiffres de votre application d'authentification pour continuer.",
      "loginButton": "login",
      "loginRecovery": "Connectez-vous avec le code de récupération"
    },
    "message": {
      "no-access": "Vous n'avez pas accès à votre appareil d'authentification? tu peux",
      "trustedBrowser": "Ignorez la vérification dans ce navigateur de confiance.",
      "recovery-requested": " Vous avez demandé à vous connecter avec un code de récupération. Cette connexion ne sera pas mémorisée tant que vous n'aurez pas fourni un code d'application d'authentification lors de la connexion ou désactivez 2FA et reconnectez-vous."
    },
    "validations": {
      "twoFactorCode": "Le champ du code d'authentification est obligatoire",
      "recoveryCode": "Le champ du code de récupération est obligatoire"
    }
  },
  "security-password-recovery": {
    "label": {
      "title": "Récupérer le mot de passe",
      "changePassword": "Changer le mot de passe",
      "userName": "Utilisateur",
      "newPassword": "nouveau mot de passe",
      "repeatPassword": "Répéter le mot de passe",
      "returnLogin": "Revenir à la connexion"
    },
    "message": {
      "email-sended": "E-mail de récupération de mot de passe envoyé",
      "password-changed": "Le mot de passe a été modifié avec succès"
    },
    "validations": {
      "newPassword": "Le nouveau mot de passe doit comporter au moins 6 caractères",
      "passwordEqual": "Les mots de passe ne correspondent pas"
    }
  },
  "reset-authenticator": {
    "label": {
      "title": "Installer l'application d'authentification",
      "reset": "Réinitialiser la clé d'authentification",
      "configure": "Configurer l'application d'authentification"
    },
    "validations": {},
    "message": {
      "alert-1": "Si vous réinitialisez votre clé d'authentification, votre application d'authentification ne fonctionnera pas tant que vous ne l'aurez pas reconfigurée.",
      "alert-2": "Ce processus désactive 2FA jusqu'à ce que vous vérifiiez votre application d'authentification.",
      "alert-3": "Si vous ne terminez pas la configuration de votre application d'authentification, vous risquez de perdre l'accès à votre compte.",
      "success": "Ihr Authentifizierungsschlüssel wurde zurückgesetzt und Sie müssen Ihre Authentifizierungs-App mit dem neuen Schlüssel konfigurieren."
    }
  },
  "tfa": {
    "title": {
      "page": "Authentification à deux facteurs"
    },
    "label": {
      "title": "Authentification à deux facteurs (2FA)",
      "authenticator-app": "Application d'authentification",
      "setup-authenticator": "Configurer l'application d'authentification",
      "add-authenticator": "Ajouter une application d'authentification",
      "reset-authenticator": "Redémarrez l'application d'authentification",
      "reset-recovery-codes": "Réinitialiser les codes de récupération",
      "disable-2fa": "Désactiver 2FA",
      "forget-this-browser": "Oubliez ce navigateur",
      "status-enabled": "Activé",
      "status-disabled": "Non configuré",
      "recovery-codes-remaining": "codes de récupération disponibles",
      "danger-zone": "Actions à fort impact"
    },
    "validations": {},
    "message": {
      "two-factor-forgotten": "Ce navigateur a été oublié. Lorsque vous vous reconnecterez dans ce navigateur, votre code 2fa vous sera demandé.",
      "no-codes-left-1": "Sie haben keine Wiederherstellungscodes verfügbar.",
      "no-codes-left-2": "Sollte",
      "no-codes-left-3": "générer un nouvel ensemble de codes de récupération",
      "no-codes-left-4": "avant de pouvoir vous connecter avec un code de récupération.",
      "some-codes-left-1": "Haben",
      "some-codes-left-2": "code (s) de récupération disponible.",
      "some-codes-left-3": "Sollte",
      "some-codes-left-4": "générer un nouvel ensemble de codes de récupération"
    }
  },
  "roles": {
    "account_reports": "Consultation de compte",
    "catalogs_admin": "Gestionnaire de catalogue",
    "details_reports": "Détails des rapports",
    "environments_admin": "Gestionnaire de variables d'environnement",
    "forms_admin": "Gestionnaire de formulaires",
    "management_report_admin": "Gestionnaire de rapports",
    "notifications_admin": "Gestionnaire de notifications",
    "system_auditor": "Auditeur système",
    "taxpayer_reports": "Demandes de renseignements des contribuables",
    "taxpayers_admin": "Administrateur des contribuables",
    "payments_admin": "Gestionnaire de paiement",
    "taxpayers_approver": "Approbateur des contribuables",
    "taxreturn_approver": "Approbateur des déclarations",
    "taxreturn_reports": "Requêtes sur les déclarations",
    "tfa_admin": "Administrateur 2FA",
    "users_admin": "Benutzer Manager",
    "current_account_admin": "Gestionnaire de compte actuel"
  },
  "taxpayer-current-account": {
    "title": {
      "currentAccount": "Compte courant",
      "amendingCredit": "Demande de solde",
      "currentAccountTransaction": "Détail des transactions",
      "transactionAdjustment": "Ajustement de la balance"
    },
    "label": {
      "tax": "Impôt",
      "taxCode": "Code fiscal",
      "period": "Période",
      "taxAmount": "Montant de la taxe",
      "penalty": "Frais de pénalité",
      "interest": "Intérêts",
      "taxArrears": "la mûre",
      "total": "Le total",
      "expirationDate": "Date d'expiration",
      "accountType": "Type de compte",
      "balance": "Solde",
      "date": "Date",
      "transactionType": "Art der Transaktion",
      "value": "Wert",
      "document": "Document",
      "justification": "Justification",
      "credit": "Crédit",
      "debit": "Débit"
    },
    "dialog": {},
    "messages": {},
    "validations": {}
  },
  "taxpayer-payments": {
    "title": {
      "page": "Demande de paiement",
      "pagePayments": "Enregistrement de paiement",
      "selectTaxReturn": "Sélectionnez Déclaration fiscale"
    },
    "label": {
      "registerPayment": "Enregistrement de paiement",
      "amountTaxReturn": "Montant de la déclaration",
      "totalDebt": "Dette totale",
      "tax-id": "Ruc",
      "name": "nom",
      "date-from": "Dater de",
      "date-to": "Date au",
      "date-payment": "Jour de paie",
      "payment-number": "Numéro de paiement",
      "exchange-rate": "Taux de change",
      "local-amount": "Montant en devise locale",
      "tax": "Impôt",
      "amount": "Montant",
      "swiftNumber": "Numéro de confirmation SWIFT"
    },
    "messages": {
      "paymentRegisteredSucessfully": "Paiement enregistré avec succès le [createDate]"
    }
  },
  "taxpayer-report": {
    "title": {
      "page": "Enquête auprès des contribuables"
    },
    "label": {
      "name": "nom",
      "nit": "Numéro d'identification fiscale",
      "county": "Pays",
      "personType": "Genre de personne",
      "email": "Poster"
    }
  },
  "taxpayer-request": {
    "label": {
      "personType": "Type de personne",
      "businessName": "Nom ou raison sociale",
      "fullName": "Nom complet",
      "id": "Numéro d'identification",
      "taxNumber": "Numéro d'identification fiscale dans le pays de résidence",
      "phoneNumber": "Numéro de téléphone",
      "domicile": "Adresse",
      "department": "Département / Province / État",
      "addContact": "Ajouter le contact",
      "operations": "Opérations",
      "contacts": "Contacts:",
      "taxVector": "Vecteur fiscal",
      "reportVector": "Rapports",
      "generalData": "Général",
      "tax": "Impôt",
      "taxObligation": "Impôt",
      "report": "Signaler",
      "website": "Site web",
      "idTax": "Numéro d'identification fiscale dans le pays de résidence",
      "contactName-tax": "Nom du contact principal",
      "docNumberContact-tax": "Numéro d'identification du contact",
      "contactTaxIdNumber-tax": "Numéro d'identification fiscale du contact dans le pays de résidence",
      "phoneNumberContact-tax": "Numéro de téléphone du contact dans le pays de résidence",
      "email-tax": "Email du contact",
      "documents": "Documents",
      "docCompanyRegistrationNumber": "Document d'enregistrement de l'entreprise",
      "docLocalContact": "Document d'identité du contact dans le pays de résidence",
      "acceptance": "Acceptation",
      "taxpayerRequest": "Enregistrement POSS",
      "confirmTerms": "Accepter les termes et conditions",
      "terms": "Lorem ipsum douleur sit amet consectetur adipiscing elit par",
      "locale": "Langue prédéfinie",
      "close": "sortir",
      "acquirerId": "Identifiant de l'acquéreur",
      "acquirerCountry": "Pays de l'acquéreur",
      "terminalId": "Identifiant du terminal",
      "merchantCategoryCode": "Code de catégorie du commerçant",
      "merchantId": "Identifiant du commerçant",
      "documentNumberCountryResidence": "Numéro de document dans le pays de résidence"
    },
    "vector": {
      "label": {
        "tax": "Impôt",
        "expiration": "Date d'expiration",
        "periodicity": "Périodicité",
        "startOperation": "Début de l'opération"
      }
    },
    "dialog": {},
    "messages": {
      "contacts": "Plus de contacts sont nécessaires",
      "operations": "Au moins une opération est requise",
      "selectOperations": "Sélectionnez les opérations correspondantes",
      "withoutOperations": "Aucune opération",
      "withoutOperationsVector": "En raison de vos opérations sélectionnées, vous n'avez pas de vecteur de taxe à présenter",
      "withoutOperationsReport": "En raison de vos opérations sélectionnées, vous n'avez aucun rapport à soumettre.",
      "withoutDocuments": "Il n'y a pas de définition de fichier",
      "successRegistrationTaxpayerTitle": "Votre requête a été envoyée.",
      "successRegistrationTaxpayerSubTitle": "Elle sera analysées et vous recevrez la réponse par email.",
      "email-tax-info": "Cette adresse électronique sera utilisée pour recevoir votre nom d'utilisateur et votre mot de passe une fois que votre demande aura été approuvée. Veuillez vérifier que les informations fournies sont correctes.",
      "contactsList": "Enregistrez vos contacts secondaires ici. Vous devez inscrire au moins un",
      "noContacts": "Aucun contact n'a été spécifié"
    },
    "validations": {
      "acceptance": "Le champ doit être sélectionné",
      "formComplete": "Remplissez le formulaire en entier"
    }
  },
  "taxpayer-request-val": {
    "title": {
      "page": "Demandes des contribuables",
      "approve": "Approuver la demande",
      "reject": "Rejeter la demande",
      "request-additional-info": "Demander des informations supplémentaires"
    },
    "label": {
      "date-from": "Dater de",
      "date-to": "Date jusqu'au",
      "request-type": "Type de demande",
      "request": "Demander",
      "type": "Nett",
      "taxpayer": "Contribuable",
      "state": "État",
      "approve": "Passe",
      "reject": "Rejeter",
      "request-additional-info": "Demander des informations supplémentaires",
      "comments": "commentaires",
      "reason": "Cause",
      "cancellationDate": "Date d'annulation"
    },
    "message": {
      "approved": "Application approuvée",
      "rejected": "Demande rejetée",
      "request-additional-info": "Demander des informations supplémentaires",
      "unsubscribe-request": "Votre demande a été reçue, vous serez avisé si votre demande a été approuvée ou rejetée."
    }
  },
  "taxpayer-taxreturns": {
    "title": {
      "page": "Consulter les rapports de déclaration",
      "subtitle": "Liste des documents enregistrés",
      "amendment": "Déposer une déclaration fiscale rectificative"
    },
    "label": {
      "nit": "Numéro d'identification fiscale",
      "taxreturnNumber": "Numéro de déclaration",
      "country": "Pays",
      "formId": "Nom de forme",
      "taxreturnType": "Type de déclaration",
      "taxreturnStatus": "État",
      "name": "Nom du contribuable",
      "period": "Période",
      "periodFrom": "Dater de",
      "periodTo": "Date jusqu'au",
      "active": "actif",
      "overview": "général",
      "taxreturn": "Déclaration",
      "createDate": "Date",
      "approve": "Approuvé",
      "comments": "commentaires"
    },
    "header": {
      "actions": "Actions",
      "nit": "Numéro d'identification fiscale",
      "name": "Nom du contribuable",
      "taxReturnNumber": "Numéro de déclaration",
      "createDate": "Date",
      "taxreturnType": "Type de déclaration",
      "taxreturnStatus": "État",
      "form": "Forme",
      "period": "Période",
      "active": "actif",
      "rejectionReason": "Raison du rejet"
    },
    "validations": {},
    "messages": {},
    "button": {}
  },
  "taxpayer-update-request": {
    "title": {
      "page": "Registrierung aktualisieren"
    }
  },
  "taxpayer-unsuscribe-request": {
    "title": {
      "page": "Se désabonner"
    }
  },
  "taxpayer-alternate-user": {
    "title": {
      "page-add": "Nouvel utilisateur alternatif",
      "page-list": "Utilisateurs alternatifs"
    },
    "label": {
      "add-user": "Ajouter un utilisateur"
    }
  },
  "login": {
    "hero": {
      "title": "Modernisation et coopération face aux défis de la fiscalité dans l'",
      "name": "Économie numérique"
    },
    "block1": {
      "title": "Une plateforme stratégique",
      "text": "pour les administrations fiscales"
    },
    "block2": {
      "title": "Un outil efficace",
      "text": "pour la gestion de la fiscalité des entreprises sans représentation physique dans la juridiction."
    },
    "block3": {
      "title": "Conçu pour faciliter",
      "text": "l'enregistrement, la déclaration et le paiement des impôts par les fournisseurs numériques étrangers."
    },

    "links": {
      "title": "Plus d'informations",
      "link1": "Documents et procédures",
      "link2": "À propos du CIAT",
      "link3": "À propos du PITAA"
    }
  },
  "appMenu": {
    "taxpayer-payment-view": "Voir les paiements",
    "taxpayer-profile-update": "Mettre à jour l'inscription",
    "unsubscribe-request-taxpayer": "Se désabonner",
    "taxpayer-payment-record": "Enregistrement de paiement",
    "taxpayer-amending-credit": "Solde de la Dette",
    "security-taxpayer": "Sécurité",
    "apikey": "Clés API",
    "two-factor-authentication-taxpayer": "Authentification à Deux Facteurs",
    "taxpayer-profile": "Profil",
    "inbox-notifications": "Notifications",
    "statements": "Déclarations de revenus",
    "file-tax-statements": "Soumettre une déclaration de revenus",
    "file-report": "Soumettre un rapport supplémentaire",
    "taxpayer-taxreturn-payments": "Paiements",
    "amendment-taxreturn": "Amendement de déclaration de revenus",
    "taxpayer-tax-returns": "Lister les déclarations de revenus",
    "taxpayer-report-details": "Lister les rapports supplémentaires"
  }
}
